"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeHUMR = function CategoryCodeHUMR(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeHUMR"), _react.default.createElement("g", {
    id: "HRLogo"
  }, _react.default.createElement("g", {
    id: "Fill-1"
  }, _react.default.createElement("path", {
    d: "M7.792,1.688A2.183,2.183,0,0,1,8.951,3.5c0,.948-1.53,3.78-.938,4.516l3.8-4.734s.944,1.149.378,2.121c-.588,1.01-2.042,2.2-2.625,3.076-.36.544-.185.836-.185.836l4.6-2.521a1.853,1.853,0,0,1-.507,1.885c-.924.833-3.1,1.163-3.1,2.031h3.161s-.323.958-.934,1.093c-.539.119-1.692-.2-2.235.293-.574.517-1.219,2.217-3.144,2.217A3.435,3.435,0,0,1,4.3,12.152c-.72-1.417-1.528-2.1-2.36-2.273A1.849,1.849,0,0,1,3.587,8.807c1.643,0,2.345,2.692,3.585,2.692a.674.674,0,0,0,.736-.713c0-.571-.823-1.044-1.053-1.2a1.678,1.678,0,0,1-.7-2l1.637-5.9"
  })))));
};

var _default = CategoryCodeHUMR;
exports.default = _default;